import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetWorkflowStateResponse, WorkflowAssignmentModel } from "../models/form.models";

@autoinject
export class FormApi {

    public platformApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    async getNeedMoreInfoAssignments(workflowStateId: number): Promise<WorkflowAssignmentModel[]> {
        const response = await this.requestClientService.post<GetWorkflowStateResponse>(`${this.platformApi}/WorkflowAssignment/GetWorkflowState`, {}, { workflowStateId: workflowStateId });
        const workflowAssignments = response.workflowState.workflowAssignments;
        return workflowAssignments.filter(x => {
            try {
                const meta: any = x.meta ? JSON.parse(x.meta) : { needMoreInfo: false };
                return meta.needMoreInfo === true;
            } catch (e) {
                return false;
            }
        });
    }
}